import { axios } from '@/services/axios';

const getPartnerPlatformNumbers = async (
    currentPartner,
    platformId,
    accountScope,
) => {
    const res = await axios.get(
        `/Partner/${currentPartner}/PlatformNumbers/${platformId}`,
        {
            headers: {
                'X-RequestScope': accountScope,
            },
        },
    );
    return res.data;
};

export default getPartnerPlatformNumbers;
